import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-code-working-outline",
  "use": "icon-code-working-outline-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-code-working-outline\"><title>Code Working</title><circle cx=\"256\" cy=\"256\" r=\"26\" /><circle cx=\"346\" cy=\"256\" r=\"26\" /><circle cx=\"166\" cy=\"256\" r=\"26\" /><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"32\" d=\"M160 368L32 256l128-112M352 368l128-112-128-112\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol